const GLOOD_UPSELL_ERROR_MESSAGE = '一部の追加商品をカートに追加できませんでした。カート内容をご確認ください。';

class AddToCartButton extends HTMLElement {
  constructor() {
    super();
    // Scope to this instance only — document.querySelectorAll would re-bind every
    // .t4s-pr-addtocart on the page for each custom element, causing N× add-to-cart.
    this.button = this.querySelector(".t4s-pr-addtocart");
    this.cart = document.querySelector("cart-drawer");
    this.quantityInput = document.querySelector("[data-quantity-value]");
    this.init();
  }

  init() {
    if (!this.button) return;
    this.button.addEventListener("click", this.handleAddToCart.bind(this));
  }

  setLoadingState(button, isLoading) {
    const spinner = button.querySelector(".loading__spinner");
    const buttonText = button.querySelector(".button-text");

    if (isLoading) {
      button.classList.add("loading");
      button.setAttribute("aria-disabled", true);
      spinner?.classList.remove("hidden");
      buttonText?.classList.add("hidden");
    } else {
      button.classList.remove("loading");
      button.removeAttribute("aria-disabled");
      spinner?.classList.add("hidden");
      buttonText?.classList.remove("hidden");
    }
  }

  async handleAddToCart(event) {
    const button = event.currentTarget;
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    this.setLoadingState(button, true);

    const config = fetchConfig("javascript");
    try {
      const formData = new FormData();
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      formData.append("id", variantId);

      const useQuantityInput = button.hasAttribute("data-quantity-control");
      const quantity = useQuantityInput
        ? parseInt(document.querySelector(".quantity__input")?.value || 1, 10)
        : 1;
      formData.append("quantity", quantity);

      if (this.cart) {
        formData.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
      }

      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();

      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: formData.get("id"),
          errors: data.errors || data.description,
          message: data.message,
        });
        this.handleErrorMessage(data.description);

        const soldOutMessage = button.querySelector(".sold-out-message");
        if (soldOutMessage) {
          button.setAttribute("aria-disabled", true);
          button.querySelector(".button-text")?.classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
        }
        this.error = true;
        return;
      }

      let gloodUpsellFailed = false;

      if (window.Glood?.upsell) {
        try {
          await Glood.upsell.commitPickSelections({
            triggerVariantId: data.variant_id
          });
          await Glood.upsell.refresh();
        } catch (e) {
          gloodUpsellFailed = true;
          console.error('[GLOOD]:[UPSELL] Error while adding upsell to cart', e);
        }
      }

      if (this.cart) {
        const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
        try {
          const sectionsResponse = await fetch(
            `${routes.cart_url}?sections=${sectionIds.join(',')}&sections_url=${encodeURIComponent(window.location.pathname)}`
          );
          const freshSections = await sectionsResponse.json();
          data.sections = freshSections;
        } catch (err) {
          console.error('Failed to refresh cart sections after upsell commit', err);
        }
      }

      document
        .querySelectorAll('[data-glood-mini-cart-line]')
        .forEach((line) => (line.dataset.gloodPriceUpdated = 'false'));

      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: formData.get("id"),
          cartData: data,
        });
      }

      this.error = false;
      this.cart.renderContents(data);
      if (gloodUpsellFailed) {
        this.cart.showCartError?.(GLOOD_UPSELL_ERROR_MESSAGE);
      } else {
        this.cart.clearCartError?.();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      this.setLoadingState(button, false);

      if (this.cart?.classList.contains("is-empty")) {
        this.cart.classList.remove("is-empty");
      }
    }
  }
}

customElements.define("add-to-cart-button", AddToCartButton);
